module.exports = __webpack_public_path__ + "img/24.18a2d874.png";